import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkForNA'
})
export class CheckNAPipe implements PipeTransform {
  public transform(val: string | number) {
    if (val === null || val === '' || val === undefined || val.toString().trim() === '') {
      return 'N/A';
    } else {
      return val;
    }
  }
}
